import * as React from 'react'
import nl2br from 'utils/nl2br'

const Office = ({ office }) => {
	return (
		<div className="grid gap-1 [&_a:hover]:underline">
			{office.title && (
				<p className="technical md:text-sm mb-1">
					<b>{office.title}</b>
				</p>
			)}
			<p>
				<a href={`tel:${office.tel}`}>{office.tel}</a>
			</p>
			<p>
				<a href={`mailto:${office.email}`}>{office.email}</a>
			</p>
			<address className="block">{nl2br(office.address)}</address>
		</div>
	)
}

export default Office
